import React, {
  useRef,
  useState,
  useCallback,
  useEffect,
} from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import LightboxCloseButton from './LightboxCloseButton';

const RootContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  transition: opacity 0.3s ease 0s;
  opacity: ${({ opacity }: {opacity: number}) => opacity};
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.85);
`;

const RootOverlay = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: -1;
`;

const CustomLightboxContainer = ({ onClose, open, children }) => {
  const containerRef = useRef();
  const [opacity, setOpacity] = useState(0);
  const closeLightbox = useCallback(() => {
    if (containerRef.current) {
      setOpacity(0);
      setTimeout(() => onClose(), 300);
    }
  }, [setOpacity, onClose]);

  useEffect(() => {
    if (open) {
      setTimeout(() => setOpacity(1), 0);
    } else {
      closeLightbox();
    }
  }, [open, closeLightbox]);

  return (
    <RootContainer ref={containerRef} opacity={opacity}>
      {/* eslint-disable-next-line */}
      <RootOverlay
        onClick={closeLightbox}
        role="dialog"
        aria-hidden="true"
      />
      {children}
      <LightboxCloseButton onClick={onClose} />
    </RootContainer>
  );
};

CustomLightboxContainer.propTypes = {
  children: PropTypes.node.isRequired,
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
};

export default CustomLightboxContainer;
